import React from "react";

export default function QuemSouEu() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      {/* Hero */}
      <section className="bg-gradient-to-r from-slate-900 to-slate-700 text-white py-20">
        <div className="max-w-5xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Quem Sou Eu</h1>
          <p className="text-xl leading-relaxed">
            Advocacia Estratégica e Humanística: <span className="font-semibold">Prevenção e Defesa</span>
          </p>
        </div>
      </section>

      {/* Conteúdo */}
      <section className="py-16">
        <div className="max-w-5xl mx-auto px-6 space-y-8 text-xl md:text-2xl leading-relaxed">
          <p>
            Com uma trajetória sólida de <strong>10 anos de atuação nos tribunais</strong>, minha prática jurídica une o rigor técnico do contencioso à visão humanística necessária para resolver conflitos complexos.
          </p>

          <p>
            Graduada pela <strong>FMU</strong> e inscrita na <strong>OAB/SP desde 2015</strong>, acumulo a experiência de mais de <strong>400 demandas</strong> nas esferas cível e criminal, defendendo os interesses de pessoas físicas, coletivos e empresas.
          </p>

          <p>
            Acredito em uma advocacia fundada na responsabilidade social. Transformo a experiência em tribunal em ferramentas de governança, aplicando o Direito Penal com foco total na <strong>prevenção de riscos</strong> nos mais variados contextos sociais.
          </p>

          <h2 className="text-3xl md:text-4xl font-bold pt-10">Especialidade em Compliance Penal e Governança</h2>

          <p>
            Desenvolvo estratégias personalizadas para antecipar crises e garantir segurança jurídica em setores sensíveis, atuando em:
          </p>

          <ul className="list-disc pl-8 space-y-4 text-xl md:text-2xl">
            <li><strong>Compliance Penal Familiar e Escolar:</strong> proteção e políticas preventivas para instituições de ensino e estruturas familiares.</li>
            <li><strong>Profissionais da Saúde:</strong> mitigação de riscos por erro médico, omissão de socorro ou violações éticas com repercussão penal.</li>
            <li><strong>Influenciadores Digitais e Figuras Públicas:</strong> prevenção de crimes contra a honra, propaganda enganosa e riscos da alta visibilidade digital.</li>
            <li><strong>Profissionais Liberais e Consultores:</strong> blindagem jurídica e prevenção à lavagem de dinheiro, conforme a Lei 9.613/98.</li>
            <li><strong>Planejamento Sucessório e Holdings Familiares:</strong> prevenção de crimes patrimoniais e fraudes na gestão de grandes patrimônios.</li>
            <li><strong>Integridade Esportiva:</strong> assessoria preventiva contra manipulação de resultados e apostas esportivas.</li>
            <li><strong>Governança Condominial:</strong> gestão de riscos penais em conglomerados residenciais.</li>
            <li><strong>Compliance Empresarial:</strong> estratégias de prevenção e defesa para empresas de diversos segmentos.</li>
          </ul>

          <h2 className="text-3xl md:text-4xl font-bold pt-10">Educação Legal e Conscientização Estratégica</h2>

          <p>
            Acredito que a informação é a ferramenta de prevenção mais eficaz. Por isso, atuo também por meio de palestras, workshops e treinamentos customizados para empresas, instituições de ensino e grupos sociais.
          </p>

          <ul className="list-disc pl-8 space-y-4 text-xl md:text-2xl">
            <li><strong>Educação Legal nas Escolas:</strong> cyberbullying, responsabilidade penal juvenil, crimes digitais e uso ético das redes sociais.</li>
            <li><strong>Treinamentos Corporativos:</strong> assédio no ambiente de trabalho, prevenção à corrupção e reflexos penais das decisões administrativas.</li>
            <li><strong>Capacitação em Condomínios:</strong> mediação de conflitos, limites da gestão e prevenção de crimes patrimoniais e interpessoais.</li>
            <li><strong>Direito para Grupos Vulneráveis:</strong> projetos de responsabilidade social e difusão de direitos fundamentais.</li>
          </ul>
        </div>
      </section>

      {/* Missão */}
      <section className="py-24 bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-8">Minha Missão</h2>
          <p className="text-xl leading-relaxed">
            Oferecer uma advocacia que não apenas resolve litígios, mas que projeta <strong>segurança, ética e prevenção</strong> por meio de políticas preventivas eficazes.
          </p>
        </div>
      </section>
    </div>
  );
}
